import { atom } from 'recoil';

export const DEFAULT_QUOTE_INFO = {
  branchNumber: '',
  enableWarranty: false,
  endUserInformation: null,
  quoteGuid: '',
  quoteLinesItems: [],
  quoteNumber: '',
};

interface EndUser {
  CompanyName: string;
}

export interface QuoteInformationAtom {
  branchNumber: string;
  enableWarranty?: boolean;
  endUserInformation: EndUser | null;
  quoteGuid: string;
  quoteLinesItems: any[];
  quoteNumber: string;
}

export const quoteInformationAtom = atom<QuoteInformationAtom>({
  default: DEFAULT_QUOTE_INFO,
  key: 'quoteInformationAtom',
});
